<fcom-notification
  [theme]="NotificationTheme.WARNING"
  class="block ms-xlarge-b"
  *ngIf="showCollectAtTheAirport$ | async"
>
  <span *ngIf="(passengerIds$ | async)?.length > 1">{{
    'MMB.checkIn.confirmation.status.boardingPass.notificationText.some' | finLocalization
  }}</span>
  <span *ngIf="(passengerIds$ | async)?.length === 1">{{
    'MMB.checkIn.confirmation.status.boardingPass.notificationText.you' | finLocalization
  }}</span>
</fcom-notification>

<fcom-notification
  [theme]="NotificationTheme.WARNING"
  class="block ms-xlarge-b"
  *ngIf="showCheckInAtTheAirport$ | async"
>
  {{ 'MMB.checkIn.confirmation.status.checkInStatus.notificationText' | finLocalization }}
</fcom-notification>

<h2 class="font-heading-2">{{ 'MMB.checkIn.confirmation.status.title' | finLocalization }}</h2>

@for (flight of flights$ | async; track flight.id) {
  <div class="white-bg border rounded-large ps-medium-y ms-xlarge-t">
    <div class="flex flex--middle nordic-blue-900-tex ps-large-b ps-medium-x">
      <fcom-icon class="ms-medium-r flex--nogrow" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL_BLOCK"></fcom-icon>
      <div class="inner-flex flex flex--wrap flex--space-between fill">
        <h2 class="flex--nogrow font-heading-3">{{ flight.departureCityName }} - {{ flight.arrivalCityName }}</h2>
        <div class="flex--end flex--self-end font-body-1">
          {{ 'operatedBy' | finLocalization: [flight.operatingAirline.name] }}
        </div>
      </div>
    </div>
    <div class="border-bottom nordic-blue-100-border"></div>

    @for (passenger of flight.passengers; track passenger.id; let first = $first) {
      <div *ngIf="!first" class="border-top-dashed ms-large-t nordic-blue-100-border"></div>

      <div class="ps-medium-x">
        <div class="ps-large-t ps-medium-b font-body-1 bold-type nordic-blue-900-text" data-hj-suppress>
          <span>{{ passenger.firstName }} {{ passenger.lastName }}</span>

          <span *ngIf="passenger.withInfant">
            ({{
              'passenger.withInfant'
                | finLocalization: { withInfantFullName: passenger.withInfant }
                | finToLowerCase: ''
            }})
          </span>
          <span *ngIf="passenger.withAdult">
            ({{
              'passengerReview.withAdult'
                | finLocalization: { withAdultFullName: passenger.withAdult }
                | finToLowerCase: ''
            }})
          </span>
        </div>

        <table>
          <tr>
            <th class="ps-medium-r align-left font-body-1 regular-type nordic-blue-400-text">
              {{ 'MMB.checkIn.confirmation.status.checkInStatus.title' | finLocalization }}
            </th>
            <td>
              <fcom-tag [theme]="passenger.status.tagTheme"
                ><fcom-icon class="ms-xxsmall-r icon-small" [name]="passenger.status.icon"></fcom-icon
                >{{
                  'MMB.checkIn.confirmation.status.checkInStatus.' + passenger.status.text | finLocalization
                }}</fcom-tag
              >
            </td>
          </tr>
          <tr>
            <th class="ps-medium-r align-left font-body-1 regular-type nordic-blue-400-text">
              {{ 'MMB.checkIn.confirmation.status.seat.title' | finLocalization }}
            </th>
            <td data-testid="boarding-pass-status-seat">
              <span class="font-body-1 medium-type nordic-blue-900-text" *ngIf="!passenger.seat.tagTheme">{{
                passenger.seat.text
              }}</span>
              <fcom-tag *ngIf="passenger.seat.tagTheme" [theme]="passenger.seat.tagTheme"
                ><fcom-icon class="ms-xxsmall-r icon-small" [name]="passenger.seat.icon"></fcom-icon
                >{{ 'MMB.checkIn.confirmation.status.seat.' + passenger.seat.text | finLocalization }}</fcom-tag
              >
            </td>
          </tr>
          <tr
            *ngIf="
              passenger.hasBoardingPasses ||
              (passenger.eligibility?.isCheckedIn === true &&
                passenger.eligibility?.isAllowedToUseBoardingPass === false)
            "
          >
            <th class="ps-medium-r align-left font-body-1 regular-type nordic-blue-400-text">
              {{ 'MMB.checkIn.confirmation.status.boardingPass.title' | finLocalization }}
            </th>
            <td *ngIf="passenger.eligibility?.isAllowedToUseBoardingPass === true">
              <div class="g-xsmall flex flex--wrap">
                @if (passenger.boardingPasses[FinnairBoardingPassDocumentType.PDF]) {
                  @let pass = passenger.boardingPasses[FinnairBoardingPassDocumentType.PDF];
                  <fcom-button
                    [attr.data-testid]="'link-button-pdf'"
                    [icon]="{ name: SvgLibraryIcon.DOWNLOAD, position: IconPosition.LEFT }"
                    [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                    [text]="'MMB.checkIn.confirmation.pdf.buttonText' | finLocalization"
                    (clickBtn)="navigateToLink(pass.link, pass.type)"
                  >
                  </fcom-button>
                }
                <div class="g-xsmall flex flex--wrap">
                  @if (passenger.boardingPasses[FinnairBoardingPassDocumentType.APPLE_WALLET]) {
                    @let pass = passenger.boardingPasses[FinnairBoardingPassDocumentType.APPLE_WALLET];
                    <button
                      [attr.data-testid]="'link-button-apple-wallet'"
                      class="apple-wallet-button"
                      [title]="'MMB.checkIn.confirmation.wallet.buttonText' | finLocalization"
                      (click)="navigateToLink(pass.link, pass.type)"
                    >
                      <fcom-icon
                        class="apple-wallet-icon black-text"
                        [class.apple-wallet-icon-fi]="isFiContent"
                        [category]="IconLibrary.CUSTOM"
                        [name]="isFiContent ? CustomIcon.APPLE_WALLET_FI : CustomIcon.APPLE_WALLET_EN"
                      ></fcom-icon>
                    </button>
                  }

                  @if (passenger.boardingPasses[FinnairBoardingPassDocumentType.GOOGLE_WALLET]) {
                    @let pass = passenger.boardingPasses[FinnairBoardingPassDocumentType.GOOGLE_WALLET];
                    <button
                      [attr.data-testid]="'link-button-google-wallet'"
                      class="google-wallet-button"
                      [title]="'MMB.checkIn.confirmation.googleWallet.buttonText' | finLocalization"
                      (click)="navigateToLink(pass.link, pass.type)"
                    >
                      <fcom-icon
                        class="google-wallet-icon black-text"
                        [class.google-wallet-icon-fi]="isFiContent"
                        [category]="IconLibrary.CUSTOM"
                        [name]="isFiContent ? CustomIcon.GOOGLE_WALLET_FI : CustomIcon.GOOGLE_WALLET_EN"
                      ></fcom-icon>
                    </button>
                  }
                </div>
              </div>
              @if (passenger.boardingPasses[FinnairBoardingPassDocumentType.GOOGLE_WALLET]) {
                <div class="font-body-2 nordic-blue-400-text ps-small-t">
                  {{ 'MMB.checkIn.confirmation.googleWallet.disclaimer' | finLocalization }}
                </div>
              }
            </td>
            <td *ngIf="passenger.eligibility?.isAllowedToUseBoardingPass === false">
              <fcom-tag [theme]="TagTheme.WARNING"
                ><fcom-icon class="ms-xxsmall-r icon-small" [name]="SvgLibraryIcon.ALERT_TRIANGLE"></fcom-icon
                >{{ 'MMB.checkIn.confirmation.status.boardingPass.collectAtTheAirport' | finLocalization }}</fcom-tag
              >
            </td>
          </tr>
        </table>
      </div>
    }
  </div>
}
